<template>
  <jumpButton :path="path" :params="params" ref="jumpButton"
              :diySetting="diySetting" :vipType="vipType"
              :share="share" v-if="path"></jumpButton>
</template>
<script>
  import App from '../util/comfun'
  import jumpButton from './jump-button.vue'
  export default {
    name: 'wxlite',
    props:{
      activity:{
        type:Object,
        value:null
      },
      submission:{
        type:Object,
        value:null
      },
      task:{
        type:Object,
        value:null
      },
      baseuser:{
        type:Object,
        value:null
      },
      diySetting:{
        type:Object,
        value:null,
      }
    },
    data(){
      return {
        path:'',
        params:null,
        share:null,
        vipType:0,
      }
    },
    components:{
      jumpButton,
    },
    methods:{
      doClick(){
        this.$refs.jumpButton.OpenLite();
      },
      greatePath(){
        let hash=location.hash
        if(hash.indexOf('#/submission')===0){
          this.vipType=this.activity.vipType
          //gotopath=/pages/picture/imagedetail&id=174005&cid=8409
          // &imgid=1405282721902695732&role=custom&share=1&drafttype=1
          this.params={
            gotopath:'/pages/picture/imagedetail',
            cid:this.submission.activityId,
            id:this.submission.id,
            imgid:1,
            role:'custom',
            share:1,
            drafttype:1,
          }
          this.share={
            title:'"'+(this.submission.autograph ? this.submission.autograph : this.submission.userName)+'" '
            +'发表了'+(this.submission.name?('「'+this.submission.name+'」'):'新作品')
            +'，欢迎围观',
            thumb:this.submission.thumb,
          }
          this.path='pages/enter/enter'
        }else if(hash.indexOf('#/home')===0){
          this.vipType=this.baseuser.vipType
          this.params={
            gotopath: '/person/pages/index',
            userId: this.baseuser.id,
          }
          this.share={
            title:'点击查看 '+this.baseuser.userName +' 的主页',
            thumb:this.baseuser.avatar,
          }
          this.path='pages/enter/enter'
        }else if(this.activity){
          this.vipType=this.activity.vipType
          if(this.task){
            //gotopath=/judge/pages/index&activityId=16443&taskId=
            this.params={
              gotopath:'/judge/pages/index',
              activityId:this.activity.activityId,
              taskId:this.task.id||'',
            }
            this.share={
              title:'诚邀您担任「'+this.activity.activityName+'」评委',
              thumb:this.activity.thumb,
            }
          }else{
            this.params={
              id:this.activity.activityId,
            }
            if(this.activity.activityId!='welcome'){
              if(false && this.activity.visibleType==1){
                this.params.gotopath='/pages/upload/detail'
              }else{
                this.params.gotopath='/pages/draftworks/work'
                this.params.frompage=1
              }
              this.share={
                title:'「'+this.activity.activityName+'」正在征稿，晒出你的作品',
                thumb:this.activity.thumb,
              }
            }else{
              this.share={
                title:'Fotoo征集一下',
                thumb:'',
              }
            }
          }
          this.path='pages/enter/enter'
        }
        document.title=this.share.title
      },
    },
    mounted(){
      this.greatePath()
    },
    created() {

    },
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/wxlite.vue